import "../css/header.scss";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);
  const [isMoreOpen, setIsMoreOpen] = useState(false);
  const moreMenuRef = useRef(null);

  const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  const toTop = () => {
    setIsMoreOpen(false);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const closeMenu = (event) => {
      if (moreMenuRef.current && !moreMenuRef.current.contains(event.target)) {
        setIsMoreOpen(false);
      }
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setIsMoreOpen(false);
    };

    document.addEventListener("mousedown", closeMenu);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("mousedown", closeMenu);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, []);

  return (
    <header className="site-header">
      <div className="header-top">
        <p>
          FREE STANDARD SHIPPING ON ORDERS OVER $129 (EXCLUDES SPECIAL CARE
          ITEMS)
        </p>
      </div>
      <div className="header-main">
        <Link to="/" onClick={toTop} className="logo-section">
          <img
            className="logo"
            src="/head/dilverbloom-logo.svg"
            alt="Dilverbloom"
          />
          <div className="tagline">
            <p>ITALIAN SPECIALTY FOOD</p>
            <p>CURATED PANTRY GOODS</p>
          </div>
        </Link>
      </div>
      <nav className="main-nav">
        <div className="nav-links">
          <Link to="/shop" onClick={toTop}>
            Shop
          </Link>

          <Link to="/contact" onClick={toTop}>
            Contact Us
          </Link>

          <Link to="/about" onClick={toTop}>
            About Dilverbloom
          </Link>

          <div className="nav-more" ref={moreMenuRef}>
            <button
              type="button"
              className="more-button"
              aria-expanded={isMoreOpen}
              aria-haspopup="true"
              onClick={() => setIsMoreOpen((open) => !open)}
            >
              More <span aria-hidden="true">⌄</span>
            </button>
            {isMoreOpen && (
              <div className="more-menu">
                <Link to="/faqs" onClick={toTop}>FAQs</Link>
                <Link to="/shipping" onClick={toTop}>Shipping</Link>
                <Link to="/returns" onClick={toTop}>Returns Policy</Link>
                <Link to="/terms" onClick={toTop}>Terms</Link>
                <Link to="/privacy" onClick={toTop}>Privacy Policy</Link>
                <Link to="/cookies" onClick={toTop}>Cookie Policy</Link>
              </div>
            )}
          </div>
        </div>
        <div className="nav-icons">
          <Link to="/cartpage" onClick={toTop} className="cart-btn">
            <svg
              width={32}
              height={32}
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="shopping_basket">
                <path
                  id="Vector"
                  d="M29.334 12.6533H22.9473L17.1073 3.90666C16.854 3.53333 16.4273 3.34666 16.0007 3.34666C15.574 3.34666 15.1473 3.53333 14.894 3.92L9.05398 12.6533H2.66732C1.93398 12.6533 1.33398 13.2533 1.33398 13.9867C1.33398 14.1067 1.34732 14.2267 1.38732 14.3467L4.77398 26.7067C5.08065 27.8267 6.10732 28.6533 7.33398 28.6533H24.6673C25.894 28.6533 26.9207 27.8267 27.2407 26.7067L30.6273 14.3467L30.6673 13.9867C30.6673 13.2533 30.0673 12.6533 29.334 12.6533ZM16.0007 7.05333L19.734 12.6533H12.2673L16.0007 7.05333ZM24.6673 25.9867L7.34732 26L4.41398 15.32H27.6007L24.6673 25.9867ZM16.0007 17.9867C14.534 17.9867 13.334 19.1867 13.334 20.6533C13.334 22.12 14.534 23.32 16.0007 23.32C17.4673 23.32 18.6673 22.12 18.6673 20.6533C18.6673 19.1867 17.4673 17.9867 16.0007 17.9867Z"
                  fill="#103729"
                />
              </g>
            </svg>

            {totalItems > 0 && <span className="cart-count">{totalItems}</span>}
          </Link>
        </div>
      </nav>
    </header>
  );
}

export default Header;
